/**
 * 강사 정체성(staff identity) 매칭 유틸.
 *
 * 수업의 `staffId`는 매핑된 강사면 숫자 `studiomateStaffId`, 미매핑 강사면
 * 문자열 `userUid`(= instructorId)다. 양쪽을 문자열로 정규화해 비교한다.
 */

import type { MembershipInfo } from "@/types/auth";

/** 강사 식별자 비교 (number/string 혼재 안전). */
export function sameStaffId(a: number | string, b: number | string): boolean {
  return String(a) === String(b);
}

/**
 * 로그인 강사의 식별자: 매핑되어 있으면 studiomateStaffId, 아니면 instructorId(=userUid).
 */
export function resolveMyStaffKey(membership: MembershipInfo): number | string {
  return membership.studiomateStaffId ?? membership.instructorId;
}
